import { render, staticRenderFns } from "./EditPayRates.vue?vue&type=template&id=483b7be4&"
import script from "./EditPayRates.vue?vue&type=script&lang=js&"
export * from "./EditPayRates.vue?vue&type=script&lang=js&"
import style0 from "./EditPayRates.vue?vue&type=style&index=0&id=483b7be4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports